if (!customElements.get('nearest-showroom')) {
    class NearestShowroom extends HTMLElement {
        constructor() {
            super();
            this.showroomData = [];
            this.nearestShowroom = [];

            this.init()
        }

        init() {
            try {
                const dataElement = document.querySelector('script[data-store-list]');
                if (dataElement) {
                    const storeList = JSON.parse(dataElement.textContent.trim());
                    // filter showroom
                    this.showroomData = storeList.filter(store => !store['store-cd'].startsWith('W'));
                    const zipCode = getCookie('mor_zipcode');
                    if (zipCode) {
                        const zipcodeElement = this.querySelector('[data-zipcode]');
                        if (zipcodeElement) {
                            zipcodeElement.textContent = zipCode;
                        }
                        const zipcodeAddressElement = this.querySelector('.nearest-showroom__description [data-zipcode-address]');
                        const zipcodeAddress = getCookie('mor_zipcode_address');
                        if (zipcodeAddressElement) {
                            zipcodeAddressElement.textContent = ' ' + (zipcodeAddress || 'you');
                        }
                        this.loading(true);
                        sortStoresByZipcode({zipCode, storeList: this.showroomData}).then(sortedStores => {
                            this.showroomData = sortedStores;
                            this.nearestShowroom = sortedStores.slice(0, 6);
                        }).catch(error => {
                            this.nearestShowroom = this.showroomData.slice(0, 6);
                            console.error('Error sorting stores by zipcode:', error);
                        }).finally(() => {
                            this.render();
                            this.loading(false);
                        })
                    }
                } else {
                    console.error('Data element with id "nearest-showroom-data" not found.');
                }
            } catch (error) {
                console.error('Error parsing showroom data:', error);
            }
        }

        loading(isLoading) {
            const spinnerParent = this.querySelector('.loading__parent');
            if (spinnerParent) {
                spinnerParent.classList.toggle('loading', isLoading);
            }
        }

        render() {
            const storeItemTemplate = this.querySelector('template');
            if (!storeItemTemplate) {
                console.error('Store item template not found.');
                return;
            }
            const storeListContainer = this.querySelector('.nearest-showroom__locations');
            if (!storeListContainer) {
                console.error('Store list container not found.');
                return;
            }
            storeListContainer.innerHTML = '';
            this.nearestShowroom.forEach(store => {
                const storeItem = storeItemTemplate.content.cloneNode(true);
                const storeAddressElement = storeItem.querySelector('[data-store-address]');
                const storeDistanceElement = storeItem.querySelector('[data-store-distance]');
                const storeLinkElement = storeItem.querySelector('[data-store-link]');
                
                if (storeAddressElement) {
                    storeAddressElement.textContent = store.city + ', ' + store.st;
                }
                if (storeLinkElement) {
                    storeLinkElement.href = `/pages/${handlizeStoreName(store['store-name'])}`;
                }
                if (storeDistanceElement) {
                    storeDistanceElement.textContent = store.distance ? `${store.distance} miles` : '';
                }
                storeListContainer.appendChild(storeItem);
            });
        }
    }

    customElements.define('nearest-showroom', NearestShowroom);
}
